import { OTPModalActionProps } from "../containers/OtpModal/OTPModal.types";

export enum OTPFormFields {
    CODE = "code",
}

export type OTPFormData = Record<OTPFormFields, string>;

export interface OTPFormProps extends OTPModalActionProps<unknown[]> {
    className?: string;
    onOTPCodeValidated?: (code: string) => void;
    onOTPCodeInvalidated?: () => void;
    onRegenerateOtp?: () => void;
    isLoading?: boolean;
}
